"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _typography = require("@vds-core/typography");

var _index = require("../../index");

var _config = _interopRequireDefault(require("./config"));

var _fonts = require("../../fonts");

var Subtitle = function Subtitle(props) {
  return /*#__PURE__*/_react["default"].createElement(_typography.Subtitle, (0, _extends2["default"])({}, props, {
    typescale: _index.TypographyConfig.getTypescale(),
    config: _config["default"],
    fontsConfig: _fonts.Fonts
  }));
};

var _default = Subtitle;
exports["default"] = _default;